import { authClient } from "@crm/access/auth/client";
import { browserEffectRuntime } from "@crm/effect/client/runtime";
import { Data, Effect } from "effect";
import { clearAccountScopedClientState } from "./account-storage";

class WorkbenchSignOutError extends Data.TaggedError("WorkbenchSignOutError")<{
  readonly cause: unknown;
}> {}

function signOutEffect(): Effect.Effect<void, WorkbenchSignOutError> {
  return Effect.tryPromise({
    try: () => authClient.signOut(),
    catch: (cause) => new WorkbenchSignOutError({ cause }),
  }).pipe(
    Effect.flatMap((result) =>
      result.error ? Effect.fail(new WorkbenchSignOutError({ cause: result.error })) : Effect.void,
    ),
    Effect.andThen(() => Effect.sync(clearAccountScopedClientState)),
  );
}

/** Sign out and leave the protected workbench in one browser operation. */
export function signOutAndLeaveWorkbench(): Promise<void> {
  return browserEffectRuntime.runPromise(
    signOutEffect().pipe(
      Effect.andThen(() =>
        Effect.sync(() => {
          window.location.assign("/login");
        }),
      ),
    ),
  );
}

/** Sign out from the standalone class progress page and reload its login view. */
export function signOutAndReloadWorkbenchPage(): Promise<void> {
  return browserEffectRuntime.runPromise(
    signOutEffect().pipe(Effect.andThen(() => Effect.sync(() => window.location.reload()))),
  );
}
